/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AccountRouteImport } from "./routes/account";
import { Route as FanRouteImport } from "./routes/fan";
import { Route as GalleryRouteImport } from "./routes/gallery";
import { Route as InvitesRouteImport } from "./routes/invites";
import { Route as MessagesRouteImport } from "./routes/messages";
import { Route as NotificationsRouteImport } from "./routes/notifications";
import { Route as OnboardingRouteImport } from "./routes/onboarding";
import { Route as PoolsRouteImport } from "./routes/pools";
import { Route as ScoresRouteImport } from "./routes/scores";
import { Route as SettingsRouteImport } from "./routes/settings";
import { Route as SignInRouteImport } from "./routes/sign-in";
import { Route as WelcomeRouteImport } from "./routes/welcome";
import { Route as AccountEditRouteImport } from "./routes/account_.edit";
import { Route as AccountFollowersRouteImport } from "./routes/account_.followers";
import { Route as AccountFollowsRouteImport } from "./routes/account_.follows";
import { Route as AccountTeamsRouteImport } from "./routes/account_.teams";
import { Route as GalleryBoxScoreRouteImport } from "./routes/gallery_.box-score";
import { Route as GalleryConfirmGateRouteImport } from "./routes/gallery_.confirm-gate";
import { Route as GalleryCreatePoolTilesRouteImport } from "./routes/gallery_.create-pool-tiles";
import { Route as GalleryDayWeekStripsRouteImport } from "./routes/gallery_.day-week-strips";
import { Route as GalleryLiveStateRouteImport } from "./routes/gallery_.live-state";
import { Route as GalleryMarksRouteImport } from "./routes/gallery_.marks";
import { Route as GalleryMatchupLiveRouteImport } from "./routes/gallery_.matchup-live";
import { Route as GalleryMatchupPregameRouteImport } from "./routes/gallery_.matchup-pregame";
import { Route as GalleryNeutralSurfacesRouteImport } from "./routes/gallery_.neutral-surfaces";
import { Route as GalleryPlayerSeasonRouteImport } from "./routes/gallery_.player-season";
import { Route as GalleryScoreRowsRouteImport } from "./routes/gallery_.score-rows";
import { Route as GallerySpacingLadderRouteImport } from "./routes/gallery_.spacing-ladder";
import { Route as GalleryWeekStripRouteImport } from "./routes/gallery_.week-strip";
import { Route as JoinCodeRouteImport } from "./routes/join.$code";
import { Route as MessagesRequestsRouteImport } from "./routes/messages_.requests";
import { Route as PoolsArchivedRouteImport } from "./routes/pools_.archived";
import { Route as PoolsSearchRouteImport } from "./routes/pools_.search";
import { Route as ScoresPlayerRouteImport } from "./routes/scores_.player";
import { Route as ScoresSearchRouteImport } from "./routes/scores_.search";
import { Route as SettingsBlockedRouteImport } from "./routes/settings_.blocked";
import { Route as SettingsSessionsRouteImport } from "./routes/settings_.sessions";
import { Route as SettingsSignInMethodsRouteImport } from "./routes/settings_.sign-in-methods";
import { Route as SignInLinkRouteImport } from "./routes/sign-in_.link";
import { Route as AccountSettingsNotificationsRouteImport } from "./routes/account_.settings.notifications";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AccountRoute = AccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => rootRouteImport,
} as any);
const FanRoute = FanRouteImport.update({
  id: "/fan",
  path: "/fan",
  getParentRoute: () => rootRouteImport,
} as any);
const GalleryRoute = GalleryRouteImport.update({
  id: "/gallery",
  path: "/gallery",
  getParentRoute: () => rootRouteImport,
} as any);
const InvitesRoute = InvitesRouteImport.update({
  id: "/invites",
  path: "/invites",
  getParentRoute: () => rootRouteImport,
} as any);
const MessagesRoute = MessagesRouteImport.update({
  id: "/messages",
  path: "/messages",
  getParentRoute: () => rootRouteImport,
} as any);
const NotificationsRoute = NotificationsRouteImport.update({
  id: "/notifications",
  path: "/notifications",
  getParentRoute: () => rootRouteImport,
} as any);
const OnboardingRoute = OnboardingRouteImport.update({
  id: "/onboarding",
  path: "/onboarding",
  getParentRoute: () => rootRouteImport,
} as any);
const PoolsRoute = PoolsRouteImport.update({
  id: "/pools",
  path: "/pools",
  getParentRoute: () => rootRouteImport,
} as any);
const ScoresRoute = ScoresRouteImport.update({
  id: "/scores",
  path: "/scores",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsRoute = SettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => rootRouteImport,
} as any);
const SignInRoute = SignInRouteImport.update({
  id: "/sign-in",
  path: "/sign-in",
  getParentRoute: () => rootRouteImport,
} as any);
const WelcomeRoute = WelcomeRouteImport.update({
  id: "/welcome",
  path: "/welcome",
  getParentRoute: () => rootRouteImport,
} as any);
const AccountEditRoute = AccountEditRouteImport.update({
  id: "/account_/edit",
  path: "/account/edit",
  getParentRoute: () => rootRouteImport,
} as any);
const AccountFollowersRoute = AccountFollowersRouteImport.update({
  id: "/account_/followers",
  path: "/account/followers",
  getParentRoute: () => rootRouteImport,
} as any);
const AccountFollowsRoute = AccountFollowsRouteImport.update({
  id: "/account_/follows",
  path: "/account/follows",
  getParentRoute: () => rootRouteImport,
} as any);
const AccountTeamsRoute = AccountTeamsRouteImport.update({
  id: "/account_/teams",
  path: "/account/teams",
  getParentRoute: () => rootRouteImport,
} as any);
const GalleryBoxScoreRoute = GalleryBoxScoreRouteImport.update({
  id: "/gallery_/box-score",
  path: "/gallery/box-score",
  getParentRoute: () => rootRouteImport,
} as any);
const GalleryConfirmGateRoute = GalleryConfirmGateRouteImport.update({
  id: "/gallery_/confirm-gate",
  path: "/gallery/confirm-gate",
  getParentRoute: () => rootRouteImport,
} as any);
const GalleryCreatePoolTilesRoute = GalleryCreatePoolTilesRouteImport.update({
  id: "/gallery_/create-pool-tiles",
  path: "/gallery/create-pool-tiles",
  getParentRoute: () => rootRouteImport,
} as any);
const GalleryDayWeekStripsRoute = GalleryDayWeekStripsRouteImport.update({
  id: "/gallery_/day-week-strips",
  path: "/gallery/day-week-strips",
  getParentRoute: () => rootRouteImport,
} as any);
const GalleryLiveStateRoute = GalleryLiveStateRouteImport.update({
  id: "/gallery_/live-state",
  path: "/gallery/live-state",
  getParentRoute: () => rootRouteImport,
} as any);
const GalleryMarksRoute = GalleryMarksRouteImport.update({
  id: "/gallery_/marks",
  path: "/gallery/marks",
  getParentRoute: () => rootRouteImport,
} as any);
const GalleryMatchupLiveRoute = GalleryMatchupLiveRouteImport.update({
  id: "/gallery_/matchup-live",
  path: "/gallery/matchup-live",
  getParentRoute: () => rootRouteImport,
} as any);
const GalleryMatchupPregameRoute = GalleryMatchupPregameRouteImport.update({
  id: "/gallery_/matchup-pregame",
  path: "/gallery/matchup-pregame",
  getParentRoute: () => rootRouteImport,
} as any);
const GalleryNeutralSurfacesRoute = GalleryNeutralSurfacesRouteImport.update({
  id: "/gallery_/neutral-surfaces",
  path: "/gallery/neutral-surfaces",
  getParentRoute: () => rootRouteImport,
} as any);
const GalleryPlayerSeasonRoute = GalleryPlayerSeasonRouteImport.update({
  id: "/gallery_/player-season",
  path: "/gallery/player-season",
  getParentRoute: () => rootRouteImport,
} as any);
const GalleryScoreRowsRoute = GalleryScoreRowsRouteImport.update({
  id: "/gallery_/score-rows",
  path: "/gallery/score-rows",
  getParentRoute: () => rootRouteImport,
} as any);
const GallerySpacingLadderRoute = GallerySpacingLadderRouteImport.update({
  id: "/gallery_/spacing-ladder",
  path: "/gallery/spacing-ladder",
  getParentRoute: () => rootRouteImport,
} as any);
const GalleryWeekStripRoute = GalleryWeekStripRouteImport.update({
  id: "/gallery_/week-strip",
  path: "/gallery/week-strip",
  getParentRoute: () => rootRouteImport,
} as any);
const JoinCodeRoute = JoinCodeRouteImport.update({
  id: "/join/$code",
  path: "/join/$code",
  getParentRoute: () => rootRouteImport,
} as any);
const MessagesRequestsRoute = MessagesRequestsRouteImport.update({
  id: "/messages_/requests",
  path: "/messages/requests",
  getParentRoute: () => rootRouteImport,
} as any);
const PoolsArchivedRoute = PoolsArchivedRouteImport.update({
  id: "/pools_/archived",
  path: "/pools/archived",
  getParentRoute: () => rootRouteImport,
} as any);
const PoolsSearchRoute = PoolsSearchRouteImport.update({
  id: "/pools_/search",
  path: "/pools/search",
  getParentRoute: () => rootRouteImport,
} as any);
const ScoresPlayerRoute = ScoresPlayerRouteImport.update({
  id: "/scores_/player",
  path: "/scores/player",
  getParentRoute: () => rootRouteImport,
} as any);
const ScoresSearchRoute = ScoresSearchRouteImport.update({
  id: "/scores_/search",
  path: "/scores/search",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsBlockedRoute = SettingsBlockedRouteImport.update({
  id: "/settings_/blocked",
  path: "/settings/blocked",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsSessionsRoute = SettingsSessionsRouteImport.update({
  id: "/settings_/sessions",
  path: "/settings/sessions",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsSignInMethodsRoute = SettingsSignInMethodsRouteImport.update({
  id: "/settings_/sign-in-methods",
  path: "/settings/sign-in-methods",
  getParentRoute: () => rootRouteImport,
} as any);
const SignInLinkRoute = SignInLinkRouteImport.update({
  id: "/sign-in_/link",
  path: "/sign-in/link",
  getParentRoute: () => rootRouteImport,
} as any);
const AccountSettingsNotificationsRoute =
  AccountSettingsNotificationsRouteImport.update({
    id: "/account_/settings/notifications",
    path: "/account/settings/notifications",
    getParentRoute: () => rootRouteImport,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/account": typeof AccountRoute;
  "/fan": typeof FanRoute;
  "/gallery": typeof GalleryRoute;
  "/invites": typeof InvitesRoute;
  "/messages": typeof MessagesRoute;
  "/notifications": typeof NotificationsRoute;
  "/onboarding": typeof OnboardingRoute;
  "/pools": typeof PoolsRoute;
  "/scores": typeof ScoresRoute;
  "/settings": typeof SettingsRoute;
  "/sign-in": typeof SignInRoute;
  "/welcome": typeof WelcomeRoute;
  "/account/edit": typeof AccountEditRoute;
  "/account/followers": typeof AccountFollowersRoute;
  "/account/follows": typeof AccountFollowsRoute;
  "/account/teams": typeof AccountTeamsRoute;
  "/gallery/box-score": typeof GalleryBoxScoreRoute;
  "/gallery/confirm-gate": typeof GalleryConfirmGateRoute;
  "/gallery/create-pool-tiles": typeof GalleryCreatePoolTilesRoute;
  "/gallery/day-week-strips": typeof GalleryDayWeekStripsRoute;
  "/gallery/live-state": typeof GalleryLiveStateRoute;
  "/gallery/marks": typeof GalleryMarksRoute;
  "/gallery/matchup-live": typeof GalleryMatchupLiveRoute;
  "/gallery/matchup-pregame": typeof GalleryMatchupPregameRoute;
  "/gallery/neutral-surfaces": typeof GalleryNeutralSurfacesRoute;
  "/gallery/player-season": typeof GalleryPlayerSeasonRoute;
  "/gallery/score-rows": typeof GalleryScoreRowsRoute;
  "/gallery/spacing-ladder": typeof GallerySpacingLadderRoute;
  "/gallery/week-strip": typeof GalleryWeekStripRoute;
  "/join/$code": typeof JoinCodeRoute;
  "/messages/requests": typeof MessagesRequestsRoute;
  "/pools/archived": typeof PoolsArchivedRoute;
  "/pools/search": typeof PoolsSearchRoute;
  "/scores/player": typeof ScoresPlayerRoute;
  "/scores/search": typeof ScoresSearchRoute;
  "/settings/blocked": typeof SettingsBlockedRoute;
  "/settings/sessions": typeof SettingsSessionsRoute;
  "/settings/sign-in-methods": typeof SettingsSignInMethodsRoute;
  "/sign-in/link": typeof SignInLinkRoute;
  "/account/settings/notifications": typeof AccountSettingsNotificationsRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/account": typeof AccountRoute;
  "/fan": typeof FanRoute;
  "/gallery": typeof GalleryRoute;
  "/invites": typeof InvitesRoute;
  "/messages": typeof MessagesRoute;
  "/notifications": typeof NotificationsRoute;
  "/onboarding": typeof OnboardingRoute;
  "/pools": typeof PoolsRoute;
  "/scores": typeof ScoresRoute;
  "/settings": typeof SettingsRoute;
  "/sign-in": typeof SignInRoute;
  "/welcome": typeof WelcomeRoute;
  "/account/edit": typeof AccountEditRoute;
  "/account/followers": typeof AccountFollowersRoute;
  "/account/follows": typeof AccountFollowsRoute;
  "/account/teams": typeof AccountTeamsRoute;
  "/gallery/box-score": typeof GalleryBoxScoreRoute;
  "/gallery/confirm-gate": typeof GalleryConfirmGateRoute;
  "/gallery/create-pool-tiles": typeof GalleryCreatePoolTilesRoute;
  "/gallery/day-week-strips": typeof GalleryDayWeekStripsRoute;
  "/gallery/live-state": typeof GalleryLiveStateRoute;
  "/gallery/marks": typeof GalleryMarksRoute;
  "/gallery/matchup-live": typeof GalleryMatchupLiveRoute;
  "/gallery/matchup-pregame": typeof GalleryMatchupPregameRoute;
  "/gallery/neutral-surfaces": typeof GalleryNeutralSurfacesRoute;
  "/gallery/player-season": typeof GalleryPlayerSeasonRoute;
  "/gallery/score-rows": typeof GalleryScoreRowsRoute;
  "/gallery/spacing-ladder": typeof GallerySpacingLadderRoute;
  "/gallery/week-strip": typeof GalleryWeekStripRoute;
  "/join/$code": typeof JoinCodeRoute;
  "/messages/requests": typeof MessagesRequestsRoute;
  "/pools/archived": typeof PoolsArchivedRoute;
  "/pools/search": typeof PoolsSearchRoute;
  "/scores/player": typeof ScoresPlayerRoute;
  "/scores/search": typeof ScoresSearchRoute;
  "/settings/blocked": typeof SettingsBlockedRoute;
  "/settings/sessions": typeof SettingsSessionsRoute;
  "/settings/sign-in-methods": typeof SettingsSignInMethodsRoute;
  "/sign-in/link": typeof SignInLinkRoute;
  "/account/settings/notifications": typeof AccountSettingsNotificationsRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/account": typeof AccountRoute;
  "/fan": typeof FanRoute;
  "/gallery": typeof GalleryRoute;
  "/invites": typeof InvitesRoute;
  "/messages": typeof MessagesRoute;
  "/notifications": typeof NotificationsRoute;
  "/onboarding": typeof OnboardingRoute;
  "/pools": typeof PoolsRoute;
  "/scores": typeof ScoresRoute;
  "/settings": typeof SettingsRoute;
  "/sign-in": typeof SignInRoute;
  "/welcome": typeof WelcomeRoute;
  "/account_/edit": typeof AccountEditRoute;
  "/account_/followers": typeof AccountFollowersRoute;
  "/account_/follows": typeof AccountFollowsRoute;
  "/account_/teams": typeof AccountTeamsRoute;
  "/gallery_/box-score": typeof GalleryBoxScoreRoute;
  "/gallery_/confirm-gate": typeof GalleryConfirmGateRoute;
  "/gallery_/create-pool-tiles": typeof GalleryCreatePoolTilesRoute;
  "/gallery_/day-week-strips": typeof GalleryDayWeekStripsRoute;
  "/gallery_/live-state": typeof GalleryLiveStateRoute;
  "/gallery_/marks": typeof GalleryMarksRoute;
  "/gallery_/matchup-live": typeof GalleryMatchupLiveRoute;
  "/gallery_/matchup-pregame": typeof GalleryMatchupPregameRoute;
  "/gallery_/neutral-surfaces": typeof GalleryNeutralSurfacesRoute;
  "/gallery_/player-season": typeof GalleryPlayerSeasonRoute;
  "/gallery_/score-rows": typeof GalleryScoreRowsRoute;
  "/gallery_/spacing-ladder": typeof GallerySpacingLadderRoute;
  "/gallery_/week-strip": typeof GalleryWeekStripRoute;
  "/join/$code": typeof JoinCodeRoute;
  "/messages_/requests": typeof MessagesRequestsRoute;
  "/pools_/archived": typeof PoolsArchivedRoute;
  "/pools_/search": typeof PoolsSearchRoute;
  "/scores_/player": typeof ScoresPlayerRoute;
  "/scores_/search": typeof ScoresSearchRoute;
  "/settings_/blocked": typeof SettingsBlockedRoute;
  "/settings_/sessions": typeof SettingsSessionsRoute;
  "/settings_/sign-in-methods": typeof SettingsSignInMethodsRoute;
  "/sign-in_/link": typeof SignInLinkRoute;
  "/account_/settings/notifications": typeof AccountSettingsNotificationsRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/account"
    | "/fan"
    | "/gallery"
    | "/invites"
    | "/messages"
    | "/notifications"
    | "/onboarding"
    | "/pools"
    | "/scores"
    | "/settings"
    | "/sign-in"
    | "/welcome"
    | "/account/edit"
    | "/account/followers"
    | "/account/follows"
    | "/account/teams"
    | "/gallery/box-score"
    | "/gallery/confirm-gate"
    | "/gallery/create-pool-tiles"
    | "/gallery/day-week-strips"
    | "/gallery/live-state"
    | "/gallery/marks"
    | "/gallery/matchup-live"
    | "/gallery/matchup-pregame"
    | "/gallery/neutral-surfaces"
    | "/gallery/player-season"
    | "/gallery/score-rows"
    | "/gallery/spacing-ladder"
    | "/gallery/week-strip"
    | "/join/$code"
    | "/messages/requests"
    | "/pools/archived"
    | "/pools/search"
    | "/scores/player"
    | "/scores/search"
    | "/settings/blocked"
    | "/settings/sessions"
    | "/settings/sign-in-methods"
    | "/sign-in/link"
    | "/account/settings/notifications";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/account"
    | "/fan"
    | "/gallery"
    | "/invites"
    | "/messages"
    | "/notifications"
    | "/onboarding"
    | "/pools"
    | "/scores"
    | "/settings"
    | "/sign-in"
    | "/welcome"
    | "/account/edit"
    | "/account/followers"
    | "/account/follows"
    | "/account/teams"
    | "/gallery/box-score"
    | "/gallery/confirm-gate"
    | "/gallery/create-pool-tiles"
    | "/gallery/day-week-strips"
    | "/gallery/live-state"
    | "/gallery/marks"
    | "/gallery/matchup-live"
    | "/gallery/matchup-pregame"
    | "/gallery/neutral-surfaces"
    | "/gallery/player-season"
    | "/gallery/score-rows"
    | "/gallery/spacing-ladder"
    | "/gallery/week-strip"
    | "/join/$code"
    | "/messages/requests"
    | "/pools/archived"
    | "/pools/search"
    | "/scores/player"
    | "/scores/search"
    | "/settings/blocked"
    | "/settings/sessions"
    | "/settings/sign-in-methods"
    | "/sign-in/link"
    | "/account/settings/notifications";
  id:
    | "__root__"
    | "/"
    | "/account"
    | "/fan"
    | "/gallery"
    | "/invites"
    | "/messages"
    | "/notifications"
    | "/onboarding"
    | "/pools"
    | "/scores"
    | "/settings"
    | "/sign-in"
    | "/welcome"
    | "/account_/edit"
    | "/account_/followers"
    | "/account_/follows"
    | "/account_/teams"
    | "/gallery_/box-score"
    | "/gallery_/confirm-gate"
    | "/gallery_/create-pool-tiles"
    | "/gallery_/day-week-strips"
    | "/gallery_/live-state"
    | "/gallery_/marks"
    | "/gallery_/matchup-live"
    | "/gallery_/matchup-pregame"
    | "/gallery_/neutral-surfaces"
    | "/gallery_/player-season"
    | "/gallery_/score-rows"
    | "/gallery_/spacing-ladder"
    | "/gallery_/week-strip"
    | "/join/$code"
    | "/messages_/requests"
    | "/pools_/archived"
    | "/pools_/search"
    | "/scores_/player"
    | "/scores_/search"
    | "/settings_/blocked"
    | "/settings_/sessions"
    | "/settings_/sign-in-methods"
    | "/sign-in_/link"
    | "/account_/settings/notifications";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AccountRoute: typeof AccountRoute;
  FanRoute: typeof FanRoute;
  GalleryRoute: typeof GalleryRoute;
  InvitesRoute: typeof InvitesRoute;
  MessagesRoute: typeof MessagesRoute;
  NotificationsRoute: typeof NotificationsRoute;
  OnboardingRoute: typeof OnboardingRoute;
  PoolsRoute: typeof PoolsRoute;
  ScoresRoute: typeof ScoresRoute;
  SettingsRoute: typeof SettingsRoute;
  SignInRoute: typeof SignInRoute;
  WelcomeRoute: typeof WelcomeRoute;
  AccountEditRoute: typeof AccountEditRoute;
  AccountFollowersRoute: typeof AccountFollowersRoute;
  AccountFollowsRoute: typeof AccountFollowsRoute;
  AccountTeamsRoute: typeof AccountTeamsRoute;
  GalleryBoxScoreRoute: typeof GalleryBoxScoreRoute;
  GalleryConfirmGateRoute: typeof GalleryConfirmGateRoute;
  GalleryCreatePoolTilesRoute: typeof GalleryCreatePoolTilesRoute;
  GalleryDayWeekStripsRoute: typeof GalleryDayWeekStripsRoute;
  GalleryLiveStateRoute: typeof GalleryLiveStateRoute;
  GalleryMarksRoute: typeof GalleryMarksRoute;
  GalleryMatchupLiveRoute: typeof GalleryMatchupLiveRoute;
  GalleryMatchupPregameRoute: typeof GalleryMatchupPregameRoute;
  GalleryNeutralSurfacesRoute: typeof GalleryNeutralSurfacesRoute;
  GalleryPlayerSeasonRoute: typeof GalleryPlayerSeasonRoute;
  GalleryScoreRowsRoute: typeof GalleryScoreRowsRoute;
  GallerySpacingLadderRoute: typeof GallerySpacingLadderRoute;
  GalleryWeekStripRoute: typeof GalleryWeekStripRoute;
  JoinCodeRoute: typeof JoinCodeRoute;
  MessagesRequestsRoute: typeof MessagesRequestsRoute;
  PoolsArchivedRoute: typeof PoolsArchivedRoute;
  PoolsSearchRoute: typeof PoolsSearchRoute;
  ScoresPlayerRoute: typeof ScoresPlayerRoute;
  ScoresSearchRoute: typeof ScoresSearchRoute;
  SettingsBlockedRoute: typeof SettingsBlockedRoute;
  SettingsSessionsRoute: typeof SettingsSessionsRoute;
  SettingsSignInMethodsRoute: typeof SettingsSignInMethodsRoute;
  SignInLinkRoute: typeof SignInLinkRoute;
  AccountSettingsNotificationsRoute: typeof AccountSettingsNotificationsRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/account": {
      id: "/account";
      path: "/account";
      fullPath: "/account";
      preLoaderRoute: typeof AccountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/fan": {
      id: "/fan";
      path: "/fan";
      fullPath: "/fan";
      preLoaderRoute: typeof FanRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/gallery": {
      id: "/gallery";
      path: "/gallery";
      fullPath: "/gallery";
      preLoaderRoute: typeof GalleryRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/invites": {
      id: "/invites";
      path: "/invites";
      fullPath: "/invites";
      preLoaderRoute: typeof InvitesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/messages": {
      id: "/messages";
      path: "/messages";
      fullPath: "/messages";
      preLoaderRoute: typeof MessagesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/notifications": {
      id: "/notifications";
      path: "/notifications";
      fullPath: "/notifications";
      preLoaderRoute: typeof NotificationsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding": {
      id: "/onboarding";
      path: "/onboarding";
      fullPath: "/onboarding";
      preLoaderRoute: typeof OnboardingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/pools": {
      id: "/pools";
      path: "/pools";
      fullPath: "/pools";
      preLoaderRoute: typeof PoolsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/scores": {
      id: "/scores";
      path: "/scores";
      fullPath: "/scores";
      preLoaderRoute: typeof ScoresRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings": {
      id: "/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof SettingsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/sign-in": {
      id: "/sign-in";
      path: "/sign-in";
      fullPath: "/sign-in";
      preLoaderRoute: typeof SignInRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/welcome": {
      id: "/welcome";
      path: "/welcome";
      fullPath: "/welcome";
      preLoaderRoute: typeof WelcomeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/account_/edit": {
      id: "/account_/edit";
      path: "/account/edit";
      fullPath: "/account/edit";
      preLoaderRoute: typeof AccountEditRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/account_/followers": {
      id: "/account_/followers";
      path: "/account/followers";
      fullPath: "/account/followers";
      preLoaderRoute: typeof AccountFollowersRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/account_/follows": {
      id: "/account_/follows";
      path: "/account/follows";
      fullPath: "/account/follows";
      preLoaderRoute: typeof AccountFollowsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/account_/teams": {
      id: "/account_/teams";
      path: "/account/teams";
      fullPath: "/account/teams";
      preLoaderRoute: typeof AccountTeamsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/gallery_/box-score": {
      id: "/gallery_/box-score";
      path: "/gallery/box-score";
      fullPath: "/gallery/box-score";
      preLoaderRoute: typeof GalleryBoxScoreRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/gallery_/confirm-gate": {
      id: "/gallery_/confirm-gate";
      path: "/gallery/confirm-gate";
      fullPath: "/gallery/confirm-gate";
      preLoaderRoute: typeof GalleryConfirmGateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/gallery_/create-pool-tiles": {
      id: "/gallery_/create-pool-tiles";
      path: "/gallery/create-pool-tiles";
      fullPath: "/gallery/create-pool-tiles";
      preLoaderRoute: typeof GalleryCreatePoolTilesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/gallery_/day-week-strips": {
      id: "/gallery_/day-week-strips";
      path: "/gallery/day-week-strips";
      fullPath: "/gallery/day-week-strips";
      preLoaderRoute: typeof GalleryDayWeekStripsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/gallery_/live-state": {
      id: "/gallery_/live-state";
      path: "/gallery/live-state";
      fullPath: "/gallery/live-state";
      preLoaderRoute: typeof GalleryLiveStateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/gallery_/marks": {
      id: "/gallery_/marks";
      path: "/gallery/marks";
      fullPath: "/gallery/marks";
      preLoaderRoute: typeof GalleryMarksRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/gallery_/matchup-live": {
      id: "/gallery_/matchup-live";
      path: "/gallery/matchup-live";
      fullPath: "/gallery/matchup-live";
      preLoaderRoute: typeof GalleryMatchupLiveRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/gallery_/matchup-pregame": {
      id: "/gallery_/matchup-pregame";
      path: "/gallery/matchup-pregame";
      fullPath: "/gallery/matchup-pregame";
      preLoaderRoute: typeof GalleryMatchupPregameRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/gallery_/neutral-surfaces": {
      id: "/gallery_/neutral-surfaces";
      path: "/gallery/neutral-surfaces";
      fullPath: "/gallery/neutral-surfaces";
      preLoaderRoute: typeof GalleryNeutralSurfacesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/gallery_/player-season": {
      id: "/gallery_/player-season";
      path: "/gallery/player-season";
      fullPath: "/gallery/player-season";
      preLoaderRoute: typeof GalleryPlayerSeasonRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/gallery_/score-rows": {
      id: "/gallery_/score-rows";
      path: "/gallery/score-rows";
      fullPath: "/gallery/score-rows";
      preLoaderRoute: typeof GalleryScoreRowsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/gallery_/spacing-ladder": {
      id: "/gallery_/spacing-ladder";
      path: "/gallery/spacing-ladder";
      fullPath: "/gallery/spacing-ladder";
      preLoaderRoute: typeof GallerySpacingLadderRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/gallery_/week-strip": {
      id: "/gallery_/week-strip";
      path: "/gallery/week-strip";
      fullPath: "/gallery/week-strip";
      preLoaderRoute: typeof GalleryWeekStripRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/join/$code": {
      id: "/join/$code";
      path: "/join/$code";
      fullPath: "/join/$code";
      preLoaderRoute: typeof JoinCodeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/messages_/requests": {
      id: "/messages_/requests";
      path: "/messages/requests";
      fullPath: "/messages/requests";
      preLoaderRoute: typeof MessagesRequestsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/pools_/archived": {
      id: "/pools_/archived";
      path: "/pools/archived";
      fullPath: "/pools/archived";
      preLoaderRoute: typeof PoolsArchivedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/pools_/search": {
      id: "/pools_/search";
      path: "/pools/search";
      fullPath: "/pools/search";
      preLoaderRoute: typeof PoolsSearchRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/scores_/player": {
      id: "/scores_/player";
      path: "/scores/player";
      fullPath: "/scores/player";
      preLoaderRoute: typeof ScoresPlayerRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/scores_/search": {
      id: "/scores_/search";
      path: "/scores/search";
      fullPath: "/scores/search";
      preLoaderRoute: typeof ScoresSearchRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings_/blocked": {
      id: "/settings_/blocked";
      path: "/settings/blocked";
      fullPath: "/settings/blocked";
      preLoaderRoute: typeof SettingsBlockedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings_/sessions": {
      id: "/settings_/sessions";
      path: "/settings/sessions";
      fullPath: "/settings/sessions";
      preLoaderRoute: typeof SettingsSessionsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings_/sign-in-methods": {
      id: "/settings_/sign-in-methods";
      path: "/settings/sign-in-methods";
      fullPath: "/settings/sign-in-methods";
      preLoaderRoute: typeof SettingsSignInMethodsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/sign-in_/link": {
      id: "/sign-in_/link";
      path: "/sign-in/link";
      fullPath: "/sign-in/link";
      preLoaderRoute: typeof SignInLinkRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/account_/settings/notifications": {
      id: "/account_/settings/notifications";
      path: "/account/settings/notifications";
      fullPath: "/account/settings/notifications";
      preLoaderRoute: typeof AccountSettingsNotificationsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  FanRoute: FanRoute,
  GalleryRoute: GalleryRoute,
  InvitesRoute: InvitesRoute,
  MessagesRoute: MessagesRoute,
  NotificationsRoute: NotificationsRoute,
  OnboardingRoute: OnboardingRoute,
  PoolsRoute: PoolsRoute,
  ScoresRoute: ScoresRoute,
  SettingsRoute: SettingsRoute,
  SignInRoute: SignInRoute,
  WelcomeRoute: WelcomeRoute,
  AccountEditRoute: AccountEditRoute,
  AccountFollowersRoute: AccountFollowersRoute,
  AccountFollowsRoute: AccountFollowsRoute,
  AccountTeamsRoute: AccountTeamsRoute,
  GalleryBoxScoreRoute: GalleryBoxScoreRoute,
  GalleryConfirmGateRoute: GalleryConfirmGateRoute,
  GalleryCreatePoolTilesRoute: GalleryCreatePoolTilesRoute,
  GalleryDayWeekStripsRoute: GalleryDayWeekStripsRoute,
  GalleryLiveStateRoute: GalleryLiveStateRoute,
  GalleryMarksRoute: GalleryMarksRoute,
  GalleryMatchupLiveRoute: GalleryMatchupLiveRoute,
  GalleryMatchupPregameRoute: GalleryMatchupPregameRoute,
  GalleryNeutralSurfacesRoute: GalleryNeutralSurfacesRoute,
  GalleryPlayerSeasonRoute: GalleryPlayerSeasonRoute,
  GalleryScoreRowsRoute: GalleryScoreRowsRoute,
  GallerySpacingLadderRoute: GallerySpacingLadderRoute,
  GalleryWeekStripRoute: GalleryWeekStripRoute,
  JoinCodeRoute: JoinCodeRoute,
  MessagesRequestsRoute: MessagesRequestsRoute,
  PoolsArchivedRoute: PoolsArchivedRoute,
  PoolsSearchRoute: PoolsSearchRoute,
  ScoresPlayerRoute: ScoresPlayerRoute,
  ScoresSearchRoute: ScoresSearchRoute,
  SettingsBlockedRoute: SettingsBlockedRoute,
  SettingsSessionsRoute: SettingsSessionsRoute,
  SettingsSignInMethodsRoute: SettingsSignInMethodsRoute,
  SignInLinkRoute: SignInLinkRoute,
  AccountSettingsNotificationsRoute: AccountSettingsNotificationsRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
